import { render, staticRenderFns } from "./BpRootBrand.vue?vue&type=template&id=55feec90&scoped=true"
import script from "./BpRootBrand.vue?vue&type=script&lang=js"
export * from "./BpRootBrand.vue?vue&type=script&lang=js"
import style0 from "./BpRootBrand.vue?vue&type=style&index=0&id=55feec90&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55feec90",
  null
  
)

export default component.exports